import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import Layout from "src/components/program/layout/Layout";
import Header from "src/components/app/layout/Header";
import Image from "src/components/common/Image";
import SEO from "src/components/common/SEO";

import supportPrograms from "src/data/app/programs";
import analytics from "src/helpers/analytics";
import { SCREEN_NAMES } from "src/helpers/analytics/events";

const ProgramListScreen: React.FC = () => {
  const supportProgramsKeys = Object.keys(supportPrograms);

  useEffect(() => {
    analytics.pageView(SCREEN_NAMES.PROGRAM_LIST_SCREEN);
  }, []);

  return (
    <Layout
      header={
        <Header
          title="Programs List"
          titlePosition="center"
          showBackButton={false}
        />
      }
      stickyHeader={true}
      enableTheme={true}
      supportProgramKey={"goodflip-care-program"}
    >
      <SEO
        title="Programs List - GoodFlip Care"
        description="List of all programs available in GoodFlip Care."
        keywords="GoodFlip Care, Personalised Support Programs, Health Support, Doctor Guidance, Monitoring"
      />
      <div className="p-4 flex flex-col gap-4">
        {supportProgramsKeys.map((programKey) => {
          const config =
            supportPrograms[programKey as keyof typeof supportPrograms];
          return (
            <Link to={`/programs/${programKey}`} key={programKey}>
              <div className="border border-gray-200 rounded-md p-4 bg-white flex items-center gap-4">
                <div className="w-[20%]">
                  <Image src={config.logo_url} alt={programKey} />
                </div>
                <div className="flex-1">
                  <h2 className="text-lg font-bold">
                    {config.support_program_name}
                  </h2>
                  <p className="text-sm text-gray-500">
                    Program Type: {config.program_type}
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </Layout>
  );
};

export default ProgramListScreen;
